export let bar = {
    title: {
        text: "Power Consumption",
        subtext: "",
        right: "center",
        //left: "center",
        //top: "center",
        textStyle: {
            fontSize: 20,
        },
        subtextStyle: {
            fontSize: 15
        }
    },
    xAxis: {
        type: 'category',
        data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
        axisTick: {
            alignWithLabel: true
        }
    },
    yAxis: {
        type: 'value',
        max: 10000,

    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'line'
        }
    },
    series: [{
        data: [4919, 5153, 4545, 4413, 4077, 4657, 5031, 5092, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        //data: [4.9, 5.6, 4.5, 4.4, 4.1, 4.7, 5.0, 5.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        type: 'bar',
        showBackground: true,
        markPoint: {
            data: [
                { type: 'max', name: 'Hai' },
                { type: 'min', name: 'Hello' },
                { coord: [5, 4657], value: 4657 },

            ]
        },
        backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)'
        },
        /* label: {
            show: true,
            position: 'inside',

        }, */
        markLine: {
            data: [
                { yAxis: 9500, name: 'Target' },
            ]
        }
    }]
};
let x = bar.xAxis.data;
let y = bar.series[0].data;

bar.series[0].markPoint.data = x.map((x, i) => {
    return { coord: [i, y[i]], value: y[i] }
})